// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import EthereumService from '@/services/ethereum'
import store from '@/store'
import bignumber from 'bignumber.js'
import VueLazyload from 'vue-lazyload'
import AmplitudeService from '@/services/amplitude'
import { vuePersistReadToLocalStorage, vuePersistWriteToLocalStorage } from '@/utils/vuePersist'
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'

// Plugin
import Vuex from 'vuex'
import Buefy from 'buefy'
import FBSignInButton from 'vue-facebook-signin-button'
import GSignInButton from 'vue-google-signin-button'
import VueTimeago from 'vue-timeago'
import VueScrollTo from 'vue-scrollto'
import VeeValidate from 'vee-validate'
import VueClipboard from 'vue-clipboard2'
import VueSocialSharing from 'vue-social-sharing'
import VueElementLoading from 'vue-element-loading'
import VuePersist from 'vue-persist'
import VueI18n from 'vue-i18n'

// Style
import '@/assets/scss/buefy.scss'
import '@/assets/css/main.css'
import '@/assets/css/custom-element.css'

// Js
import '@/assets/js/facebookSDK'
import messages from './i18n'

// Filter
import './utils/viewFilter'

// Validator
import './utils/validator'

bignumber.config({
  DECIMAL_PLACES: 20,
  FORMAT: {
    decimalSeparator: '.',
    groupSeparator: ',',
    groupSize: 3
  }
})

Vue.prototype.$ethereum = new EthereumService()

Vue.use(Vuex)
Vue.use(Buefy)
Vue.use(VueTimeago)
Vue.use(VueScrollTo)
Vue.use(FBSignInButton)
Vue.use(GSignInButton)
Vue.use(VeeValidate)
Vue.use(VueClipboard)
Vue.use(VueSocialSharing)
Vue.use(VueLazyload)
Vue.use(VuePersist, {
  expiration: 1000 * 60 * 60 * 720, //  persistet expiration in 1 month
  write: vuePersistWriteToLocalStorage,
  read: vuePersistReadToLocalStorage
})
Vue.use(VueI18n)

Vue.config.productionTip = false
Vue.config.errorHandler = (err, vm, info) => {
  AmplitudeService.vuejsHandlerError(err, vm, info)
}
Vue.component('VueElementLoading', VueElementLoading)
Vue.component('vue-cookie-accept-decline', VueCookieAcceptDecline)

Vue.directive('visible', function (el, binding) {
  el.style.visibility = !!binding.value ? 'visible' : 'hidden' // eslint-disable-line
})

const userLang = (localStorage.getItem('KULAP.user-lang') || navigator.language || navigator.userLanguage || 'en-US').split('-')[0]
const i18n = new VueI18n({
  locale: userLang === 'th' ? 'th' : 'en', // set locale
  messages // set locale messages
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js